import React, { useState, useEffect, useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Box, Loader } from '@paygreen/paygreen-ui';
import { useAPIError, useMode } from '../../../../context';
import { ModalForm, ErrorBoundary } from '../../../../components';
import { getOneFootprint } from '../../service';
import OffsetsDetailsDisplay from './OffsetsDetailsDisplay';

const OffsetsDetailsModal = ({ isOpen, idFootprint, t }) => {
    const { addError } = useAPIError();
    const { mode } = useMode();

    // we create a ref to detect if component is mounted
    const isMounted = useRef(false);

    const [isLoading, setIsLoading] = useState(false);
    const [offsetsDetails, setOffsetsDetails] = useState();

    /**
     * Get request to API to get details per offset
     */
    const getOffsetsDetails = useCallback(() => {
        setIsLoading(true);

        getOneFootprint(idFootprint, mode)
            .then((res) => {
                isMounted.current && setOffsetsDetails(res.data);
            })
            .catch((error) =>
                addError(
                    error?.response?.data.detail,
                    error?.response?.data.status,
                ),
            )
            .finally(() => {
                isMounted.current && setIsLoading(false);
            });
    }, [addError, idFootprint, mode]);

    useEffect(() => {
        isMounted.current = true;

        if (isOpen) {
            getOffsetsDetails();
        }

        return () => {
            isMounted.current = false;
        };
    }, [getOffsetsDetails, isOpen]);

    return (
        <ModalForm
            modalTitle={t('offsets.details.modalTitle')}
            blockWidth="md"
            isOpen={isOpen}
        >
            {isLoading ? (
                <Box margin="md">
                    <Loader />
                </Box>
            ) : (
                <ErrorBoundary>
                    <OffsetsDetailsDisplay
                        isLoading={isLoading}
                        data={offsetsDetails}
                    />
                </ErrorBoundary>
            )}
        </ModalForm>
    );
};

OffsetsDetailsModal.propTypes = {
    idFootprint: PropTypes.string.isRequired,
    /**
     * @description isOpen is automatically received from ModalControl parent
     */
    isOpen: PropTypes.bool,
};

export default withTranslation('common')(OffsetsDetailsModal);
